export default {"src":"/_next/static/media/Line 54.2809f83a.svg","height":193,"width":6,"blurWidth":0,"blurHeight":0};